export default {
  uk: { symbol: "\u20B4", label: "грн" }
}
